import * as R from 'ramda';

export default function AddEditDocumentDialogController(
  ssDialogService,
  loaderService,
  alerts,
  confirmDialog,
  documentAssociationDialog,
  docDataService
) {
  const vm = this;

  vm.handleSaveDialogClick = _handleSaveDialogClick;
  vm.handleCloseDialogClick = _handleCloseDialogClick;
  vm.handleDocumentServiceVisiblityChange = _handleDocumentServiceVisiblityChange;
  vm.handleSomeSelectedCheck = _handleSomeSelectedCheck;

  vm.customerId = vm.customerId || 0;
  vm.documentId = vm.documentId || null;
  vm.folderId = vm.folderId || -1;
  vm.serviceId = vm.serviceId || null;
  vm.documentName = vm.documentName || null;
  vm.parentFolder = vm.parentFolder || null;
  vm.document = vm.document || null;
  vm.documentAssociations = [];
  vm.serviceChanged = null;
  vm.selectedServices = {};

  _activate();

  function _activate() {
    loaderService.showViewLoader = true;

    docDataService.getDocumentVisiblities(vm.documentId)
      .then((ret) => {
        vm.document.documentVisibilities = ret.data.result;
        angular.forEach(vm.document.customerServices, (custService) => {
          angular.forEach(vm.document.documentVisibilities, (documentVisibility) => {
            if (custService.serviceId === documentVisibility.serviceId) {
              vm.selectedServices[custService.serviceId] = true;
            }
          });
        });
      }).finally(() => {
        loaderService.showViewLoader = false;
      });

    // loaderService.showViewLoader = true;
    //
    // const dfdAssoc = docDataService.getDocumentAssociations(vm.documentId, null);
    // dfdAssoc.then((isSuccess) => {
    //   if ((isSuccess.statusText === 'OK') || (isSuccess.statusText === '')) {
    //     vm.documentAssociations = isSuccess.data;
    //   }
    // }).finally(() => {
    //   loaderService.showViewLoader = false;
    // });
  }

  function _handleSomeSelectedCheck(object) {
    return Object.keys(object).some(key => object[key]);
  }

  function _handleSaveDialogClick(form) {
    if (form.$valid) {
      loaderService.showViewLoader = true;
      // Save Document

      vm.document.assignments = '';
      angular.forEach(vm.document.customerServices, (customerService) => {
        if (vm.selectedServices[customerService.serviceId]) {
          if (vm.document.assignments === '') {
            vm.document.assignments = customerService.serviceId;
          } else {
            vm.document.assignments = `${vm.document.assignments},${customerService.serviceId}`;
          }
        }
      });
      docDataService.saveDocumentProperties(vm.serviceId, vm.document)
        .then((saveResult) => {
          if (saveResult.statusText === 'OK') {
            docDataService.getDocumentVisiblities(vm.document.documentId)
              .then((getResult) => {
                vm.document.documentVisibilities = getResult.data.result;

                if (vm.updateCallback) {
                  vm.updateCallback(vm.parentFolder, vm.document);
                }

                alerts.success('Document has been saved successfully.');
                ssDialogService.hide(ssDialogService.dialogs.global.addEditDocumentDialog);
              });
          } else {
            alerts.error('An error occurred while saving the document.');
          }
        })
        .finally(() => {
          loaderService.showViewLoader = false;
        });
    }
  }

  function _handleCloseDialogClick() {
    ssDialogService.hide(ssDialogService.dialogs.global.addEditDocumentDialog);
  }

  // function _handleAcceptDocumentAssociationDelete($event, parentFolder, document, service) {
  //   ssDialogService.dialogs.global.documentManagementDeleteDocumentDialog = ssDialogService.alert(
  //     confirmDialog.getOptions($event, {
  //       dialogTitle: 'Remove Association?',
  //       message: `Are you sure you want to remove the associations for file ${vm.documentName}?`,
  //       handleYesClick: vm.handleYesDeleteFolderDialogClick,
  //       handleNoClick: vm.handleCloseDeleteFolderDialogClick,
  //       referenceObject: {
  //         parentFolder,
  //         document,
  //         service
  //       },
  //     }),
  //   );
  //
  //   ssDialogService.show(ssDialogService.dialogs.global.documentManagementDeleteDocumentDialog);
  // }

  function _handleDeclineDocumentAssociationDelete() {
    vm.serviceChanged.isSelected = true;
  }

  function _handleDocumentServiceVisiblityChange($event, serviceChanged) {
    if (serviceChanged.isSelected === false) {
      vm.serviceChanged = serviceChanged;
      const assocs = R.filter(d => d.serviceId === serviceChanged.serviceId, vm.documentAssociations);

      if (assocs.length > 0) {
        _showDocumentAssociationsDialog($event, {
          folderId: null,
          documentId: vm.documentId,
          serviceId: serviceChanged.serviceId,
          service: serviceChanged,
          associations: assocs,
          document: vm.document,
          folder: null,
          acceptCallback: null, // _handleAcceptDocumentAssociationDelete,
          declineCallback: _handleDeclineDocumentAssociationDelete
        });
      }
    }
  }

  function _showDocumentAssociationsDialog($event, locals) {
    ssDialogService.dialogs.global.documentAssociationDialog = ssDialogService.alert(
      documentAssociationDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.global.documentAssociationDialog);
  }
}

AddEditDocumentDialogController.$inject = [
  'ssDialogService',
  'loaderService',
  'alerts',
  'confirmDialog',
  'documentAssociationDialog',
  'docDataService'
];
